import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'lectern',
  size: 24,
  node: [
    [
      'path',
      {
        d: 'M15 13h4a2 2 0 001.901-1.38l1.057-4.333A1 1 0 0021 6H3a1 1 0 00-.958 1.287L3.1 11.621A2 2 0 005.001 13h4',
        key: 'uu7fz6',
      },
    ],
    ['path', { d: 'M15 22V11a1 1 0 00-1-1h-4a1 1 0 00-1 1v11', key: 'hedff3' }],
    ['path', { d: 'M18 22H6', key: 'mg6kv4' }],
    ['path', { d: 'M18 6V3a1 1 0 00-1-1h-3', key: '1y10qe' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Lectern
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMTNoNGEyIDIgMCAwMDEuOTAxLTEuMzhsMS4wNTctNC4zMzNBMSAxIDAgMDAyMSA2SDNhMSAxIDAgMDAtLjk1OCAxLjI4N0wzLjEgMTEuNjIxQTIgMiAwIDAwNS4wMDEgMTNoNCIgLz4KICA8cGF0aCBkPSJNMTUgMjJWMTFhMSAxIDAgMDAtMS0xaC00YTEgMSAwIDAwLTEgMXYxMSIgLz4KICA8cGF0aCBkPSJNMTggMjJINiIgLz4KICA8cGF0aCBkPSJNMTggNlYzYTEgMSAwIDAwLTEtMWgtMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/lectern
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Lectern = createLucideIcon(__iconData);

export default Lectern;
